/**
 * PasswordStrength - 비밀번호 강도 표시 컴포넌트
 *
 * 4단계 세그먼트 바와 텍스트 라벨로 비밀번호 강도를 시각적으로 표시.
 * @param password - 평가할 비밀번호 문자열
 */
'use client';

import React, { useMemo } from 'react';
import { calculatePasswordStrength } from '@/lib/passwordStrength';
import styles from './PasswordStrength.module.css';

interface PasswordStrengthProps {
  password: string;
}

export default function PasswordStrength({ password }: PasswordStrengthProps) {
  const strength = useMemo(() => calculatePasswordStrength(password), [password]);

  if (!password) return null;

  const getSegmentClass = (index: number): string => {
    if (strength.score <= index) return '';
    switch (strength.level) {
      case 'weak':
        return styles.segmentWeak;
      case 'medium':
        return styles.segmentMedium;
      case 'strong':
        return styles.segmentStrong;
      case 'very-strong':
        return styles.segmentVeryStrong;
      default:
        return '';
    }
  };

  const getLabelClass = (): string => {
    switch (strength.level) {
      case 'weak':
        return styles.strengthWeak;
      case 'medium':
        return styles.strengthMedium;
      case 'strong':
        return styles.strengthStrong;
      case 'very-strong':
        return styles.strengthVeryStrong;
      default:
        return '';
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.barTrack}>
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`${styles.segment} ${getSegmentClass(i)}`} />
        ))}
      </div>
      <div className={`${styles.label} ${getLabelClass()}`}>{strength.label}</div>
    </div>
  );
}
